import { Route, Switch } from "wouter";
import { Diary } from "./pages/Diary.tsx";
import { Home } from "./pages/Home.tsx";
import { Profile } from "./pages/Profile.tsx";
import { Register } from "./pages/Register.tsx";
import { Shifts } from "./pages/Shifts.tsx";

export function App() {
	return (
		<div className="min-h-screen">
			<Switch>
				<Route path="/" component={Home} />
				<Route path="/register" component={Register} />
				<Route path="/shifts" component={Shifts} />
				<Route path="/diary" component={Diary} />
				<Route path="/profile" component={Profile} />
				<Route>
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}

function NotFound() {
	return (
		<main className="mx-auto max-w-md px-4 py-16 text-center">
			<h1 className="text-lg font-semibold">ページが見つかりません</h1>
			<p className="mt-2 text-sm text-gray-600">
				URL を確認してください。招待リンクを開き直すと登録画面に遷移します。
			</p>
		</main>
	);
}
